import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringFilter'
})
export class StringFilterPipe implements PipeTransform {

//   transform(value: string[], q: string) {
//         if (!q || q === '') {
//             return value;
//         }
//         return value.filter(item => -1 < item.toLowerCase().indexOf(q.toLowerCase()));
//     }

  transform(categories: any, searchText: any): any {
    if(categories == null){
      return null;
    }
    if (searchText == null) return categories;

    return categories.filter(function (category) {
      console.log(searchText);
      return category.serviceprovidertype.toLowerCase().indexOf(searchText.toLowerCase()) > -1 || category.company_name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 || category.phone.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      //return category.email.indexOf(searchText) > -1;
    })
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/-pipe/string-filter/string-filter.pipe.ts